import { render, staticRenderFns } from "./CompletionDot.vue?vue&type=template&id=796975ac&"
import script from "./CompletionDot.vue?vue&type=script&lang=js&"
export * from "./CompletionDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports